// src/features/product-tours/guideEligibility.ts

import { isFeatureEnabled } from '../../types/business';
import type { GuideAvailabilityContext, GuideEligibility, ProductTourDefinition } from './types';

/**
 * Un guide n’est listé / lancé que si features + permissions (et mobile si requis) passent.
 * Les sélecteurs DOM sont gérés au runtime (waitForElement) après navigation.
 */
export function isGuideEligible(
  eligibility: GuideEligibility | undefined,
  ctx: GuideAvailabilityContext
): boolean {
  if (!eligibility) return true;

  if (eligibility.requiresMobile && !ctx.isMobileViewport) {
    return false;
  }

  const features = eligibility.requiresFeatures || [];
  for (const feature of features) {
    if (!isFeatureEnabled(ctx.business, feature)) return false;
  }

  const perms = eligibility.requiresPermissions || [];
  if (perms.length > 0) {
    if (!ctx.permissions) return false;
    for (const key of perms) {
      if (ctx.permissions[key] !== true) return false;
    }
  }

  const anyPerms = eligibility.requiresAnyPermissions || [];
  if (anyPerms.length > 0) {
    if (!ctx.permissions) return false;
    if (!anyPerms.some((key) => ctx.permissions![key] === true)) return false;
  }

  return true;
}

export function isTourDefinitionEligible(
  def: ProductTourDefinition | undefined,
  ctx: GuideAvailabilityContext
): boolean {
  if (!def) return false;
  return isGuideEligible(def.eligibility, ctx);
}
